import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const SolutionItem = ({ image, titleheader, title, check }) => {
  const { i18n } = useTranslation();
  const { width } = useWindowSize();
  return (
    <div
      className={`transition-border  transition-radius mr-[30px] rounded-[20px] transition-colors transition-shadow duration-500 duration-500 duration-500  ease-in-out sm:mr-0 ${check ? "" : "hover:shadow-have-a-look-hover"}   ${i18n.language === "en" ? (width > 1230 ? "h-[440px]" : "h-none") : ""}  relative overflow-hidden  sm:mr-0`}
    >
      <div
        className={`mb-[1px] flex max-w-[400px]   flex-col rounded-[20px] bg-white  p-[20px]  lgmax:max-w-none `}
      >
        <div className="h-[100px] w-[100px] rounded-[50px]  shadow-benefits">
          <img className="p-[25px]" src={image} />
        </div>
        <div className="mt-[25px] flex flex-col gap-[10px]">
          <h3 className="bg-[-100%] text-[24px] font-semibold text-[--color-hover]">
            {titleheader}
          </h3>
          <p className="text-4  font-normal text-[--color-text] group-hover:animate-text">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};
SolutionItem.propTypes = {
  image: PropTypes.string,
  titleheader: PropTypes.string,
  title: PropTypes.string,
  check: PropTypes.bool,
};
